import PropTypes from "prop-types"
import React, { useMemo } from "react"

import moment from "moment"
import WeekGrid from "./WeekGrid"
import DayGrid from "./DayGrid"
import { DEFAULT_END_HOUR, DEFAULT_START_HOUR } from "pagesV2/pro/Calendar/constants"

const CalendarTimeGrid = ({ date, events = [], type, journalNoteDates = [], onJournalClick }) => {
  const hours = Array.from({ length: DEFAULT_END_HOUR - DEFAULT_START_HOUR + 1 }, (_, i) => DEFAULT_START_HOUR + i)
  const weekStartDate = useMemo(() => moment(date).startOf("isoWeek"), [date])
  const weekEndDate = useMemo(() => moment(date).endOf("isoWeek"), [date])

  const calendarDaysCount = useMemo(() => weekEndDate.diff(weekStartDate, "days") + 1, [weekStartDate, weekEndDate])
  const calendarDays = useMemo(
    () => new Array(calendarDaysCount).fill().map((_, index) => weekStartDate.clone().add(index, "days")),
    [weekStartDate, calendarDaysCount]
  )

  if (type === "week") {
    return <WeekGrid calendarDays={calendarDays} hours={hours} events={events} journalNoteDates={journalNoteDates} onJournalClick={onJournalClick} />
  }

  return <DayGrid date={date} calendarDays={calendarDays} hours={hours} events={events} journalNoteDates={journalNoteDates} onJournalClick={onJournalClick} />
}

CalendarTimeGrid.propTypes = {
  type: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      start: PropTypes.number,
      end: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string
    })
  ),
  journalNoteDates: PropTypes.array,
  onJournalClick: PropTypes.func
}

export default CalendarTimeGrid
